import React from 'react';
import { connect } from 'react-redux';
import { OwnershipTransferActionType, RequestStatus, FormSendType } from '../Constant/Constant';
import SuccessPageOneForm from './SuccessPageOneForm';
import SuccessPageTwoForms from './SuccessPageTwoForms';
import GeneralMessage from '../Steps/GeneralMessage';
import { dwhGeneralReport, dwhDashboardReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'
import {transferOption} from "app/Components/Block/TransferOrganizationAccountBlock/Constant/Constant";


const SuccessPage = (props) => {
console.log(props)
  function getSuccessPage() {
    dwhGeneralReport({
      data: { ...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock },
      actionType: DwhActionType.SuccessScreen,
      messageText: DWHMessageText.SuccessScreen,
      status: DWHStatus.Completed,
    });
    if (props.data.selectedActionType == OwnershipTransferActionType.FullFundingToSeparate)
      return <SuccessPageOneForm nextStepSuccessPage={props.nextStepSuccessPage} />;
    else return <SuccessPageTwoForms nextStepSuccessPage={props.nextStepSuccessPage} resendForms={true} />;
  }

  function getResendSuccessPage() {

    dwhDashboardReport({
      data: { row: props.data.dashboardData.find((r) => r.id == props.data.requestId), userDetails: props.userDetails, portalsBlock: props.portalsBlock },
      actionType: DwhActionType.SuccessScreen,
      messageText: DWHMessageText.ResendingSuccessScreen,
      status: DWHStatus.Completed,
    });

    const editedRow = props.data.dashboardData.find((row) => row.id === parseInt(props.data.requestId));
    if (editedRow.actionType == OwnershipTransferActionType.BusinessToPrivate && editedRow.statusCodeDescription == RequestStatus.AwaitingSubscriberSignature) {
      const messageData = {
        title: props.data.subscriberSendFormType.type == FormSendType.email ? `טופס לחתימה של המנוי נשלח שוב לכתובת המייל שהזנת` : ` טופס לחתימה של המנוי נשלח שוב למספר ${props.data.subscriberSendFormType.sms}`,
        secondTitle: props.data.subscriberSendFormType.type == FormSendType.email ? props.data.subscriberSendFormType.email : '',
        icon: require('../Icons/v.svg'),
        buttonText: 'לצפייה בכל העברות הבעלות',
        secondButtonText: 'לאזור האישי',
      }
      return <GeneralMessage messageData={messageData} buttonClick={props.nextStepSuccessPage} secondButtonClick={props.goToLobby} data={props.data}             isNewLineAction={props.data.selectedTransferOption === transferOption.newLine}
      />;
    }
    else if (editedRow.actionType == OwnershipTransferActionType.PrivateToBusiness && editedRow.statusCodeDescription == RequestStatus.AwaitingContactPersonSignature) {
      const messageData = {
        title: props.data.contactPersonSendFormType.type == FormSendType.email ? `טופס לחתימה שלך נשלח בהצלחה לכתובת המייל שהזנת` : ` טופס לחתימה שלך נשלח בהצלחה למספר ${props.data.contactPersonSendFormType.sms}`,
        secondTitle: props.data.contactPersonSendFormType.type == FormSendType.email ? props.data.contactPersonSendFormType.email : '',
        icon: require('../Icons/v.svg'),
        buttonText: 'לצפייה בכל העברות הבעלות',
        secondButtonText: 'לאזור האישי',
      }
      return <GeneralMessage messageData={messageData} buttonClick={props.nextStepSuccessPage} secondButtonClick={props.goToLobby} data={props.data}             isNewLineAction={props.data.selectedTransferOption === transferOption.newLine}/>;

    }

    else return <SuccessPageTwoForms nextStepSuccessPage={props.nextStepSuccessPage} resendForms={true} />;
  }

  function getResendMLSuccessPage() {
    let messageData;
    if (props.data.subscriberSendFormType.type == FormSendType.email) {
      messageData = {
        title: ` טופס לחתימה של המנוי נשלח שוב לכתובת המייל שהזנת`,
        secondTitle: props.data.subscriberSendFormType.email,
        icon: require('../Icons/v.svg'),
        buttonText: 'לצפייה בכל העברות הבעלות',
        secondButtonText: 'לאזור האישי',
      }
    }
    else {
      messageData = {
        title: ` טופס לחתימה של המנוי נשלח שוב למספר ${props.data.subscriberSendFormType.sms}`,
        icon: require('../Icons/v.svg'),
        buttonText: 'לצפייה בכל העברות הבעלות',
        secondButtonText: 'לאזור האישי',
      }

    }

    return <GeneralMessage messageData={messageData} buttonClick={props.nextStepSuccessPage} secondButtonClick={props.goToLobby} data={props.data} isNewLineAction={props.data.selectedTransferOption === transferOption.newLine}/>;

  }
  return (
    <>
      {props.resendForms && <div getResendSuccessPage className='cp-success-page ownership-transfer-step'>{getResendSuccessPage()}</div>}
      {props.resendML && <div getResendSuccessPage className='cp-success-page ownership-transfer-step'>{getResendMLSuccessPage()}</div>}
      {!props.resendML && !props.resendForms && <div className='cp-success-page ownership-transfer-step'>{getSuccessPage()}</div>}
    </>
  )
};
const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  userDetails: state.authentication?.loginData?.userDetails,
  portalsBlock: state.portalsBlock,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
